import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _styled from "styled-components";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useCallback, useEffect } from 'react';
import usePlacesAutocomplete from 'use-places-autocomplete';
import { MapPinIcon } from '@heroicons/react/24/outline';
import { MarkerPinIcon } from '@restworld/utils-common';
import { ChipCheckBox } from '@restworld/ui-ds-base';
import { Title } from '../..';
import { GoogleAutoCompleteAddressItemStyled } from './google-auto-complete-input.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

// for esp. employer onboarding page
var AddressSelectDropdown = function AddressSelectDropdown(_ref) {
  var data = _ref.data,
      setCardOverlay = _ref.setCardOverlay,
      onLocationInputChange = _ref.onLocationInputChange,
      onSuggestionSelect = _ref.onSuggestionSelect,
      dropdownItemProps = _ref.dropdownItemProps;

  var _ref2 = dropdownItemProps || {},
      onClick = _ref2.onClick,
      activeItem = _ref2.activeItem;

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [data.map(function (suggestion, index) {
      var handleClick = function handleClick() {
        if (onClick) {
          onClick(place_id, "".concat(main_text, " ").concat(secondary_text || ''), secondary_text || '');
          return;
        }

        setCardOverlay(false);
        onLocationInputChange("".concat(main_text, " ").concat(secondary_text || ''));
        onSuggestionSelect(suggestion);
      };

      var place_id = suggestion.place_id,
          _suggestion$structure = suggestion.structured_formatting,
          main_text = _suggestion$structure.main_text,
          secondary_text = _suggestion$structure.secondary_text;
      var isActiveItem = activeItem === place_id;
      return /*#__PURE__*/_jsx("li", {
        onClick: handleClick,
        "data-cy": "address-suggestion-".concat(index),
        "aria-label": "restaurant-places",
        children: /*#__PURE__*/_jsx(ChipCheckBox, {
          Icon: MapPinIcon,
          checked: isActiveItem,
          id: place_id,
          label: "".concat(main_text).concat(secondary_text ? ", ".concat(secondary_text) : ''),
          wrapperStyles: {
            "width": "100%"
          }
        })
      }, place_id);
    }), dropdownItemProps === null || dropdownItemProps === void 0 ? void 0 : dropdownItemProps.item]
  });
};

var AddressDirectApplyList = function AddressDirectApplyList(_ref3) {
  var data = _ref3.data,
      setCardOverlay = _ref3.setCardOverlay,
      onLocationInputChange = _ref3.onLocationInputChange,
      onSuggestionSelect = _ref3.onSuggestionSelect,
      dropdownItemProps = _ref3.dropdownItemProps;

  var _ref4 = dropdownItemProps || {},
      activeItem = _ref4.activeItem,
      onClick = _ref4.onClick,
      itemTextStyle = _ref4.itemTextStyle,
      suffixIcon = _ref4.suffixIcon,
      dropdownItemStyle = _ref4.dropdownItemStyle,
      activeItemStyle = _ref4.activeItemStyle;

  return /*#__PURE__*/_jsx(_Fragment, {
    children: data.map(function (suggestion, index) {
      var handleClick = function handleClick() {
        if (onClick) {
          onClick(place_id, "".concat(main_text, " ").concat(secondary_text || ''), secondary_text || '');
          return;
        }

        setCardOverlay(false);
        onLocationInputChange("".concat(main_text, " ").concat(secondary_text || ''));
        onSuggestionSelect(suggestion);
      };

      var place_id = suggestion.place_id,
          _suggestion$structure2 = suggestion.structured_formatting,
          main_text = _suggestion$structure2.main_text,
          secondary_text = _suggestion$structure2.secondary_text;
      var isActiveItem = activeItem === place_id;
      return /*#__PURE__*/_jsxs(GoogleAutoCompleteAddressItemStyled, {
        "data-cy": "address-suggestion-".concat(index),
        onClick: handleClick,
        dropdownItemStyle: dropdownItemStyle,
        isActive: isActiveItem,
        activeItemStyle: activeItemStyle,
        "aria-label": "restaurant-places",
        children: [/*#__PURE__*/_jsxs(_StyledDiv, {
          children: [/*#__PURE__*/_jsx(_StyledMarkerPinIcon, {}), /*#__PURE__*/_jsxs(_StyledDiv2, {
            children: [/*#__PURE__*/_jsx(Title, {
              content: main_text,
              fontWeight: "normal",
              fontSize: "small",
              twStyle: {
                "lineHeight": "1.313rem"
              }
            }), main_text && secondary_text && /*#__PURE__*/_jsx(Title, {
              content: secondary_text,
              fontWeight: "normal",
              fontSize: "small",
              twStyle: itemTextStyle ? itemTextStyle : {
                "lineHeight": "1.313rem"
              }
            })]
          })]
        }), suffixIcon]
      }, place_id);
    })
  });
};

var usePlacesAutocompleteLogic = function usePlacesAutocompleteLogic(_ref5) {
  var _ref6, _ref6$google, _ref6$google$maps;

  var placesFilterTypes = _ref5.placesFilterTypes,
      isScriptReady = _ref5.isScriptReady,
      sessionTokenRef = _ref5.sessionTokenRef,
      placesLocationBias = _ref5.placesLocationBias;
  useEffect(function () {
    if (isScriptReady && true && window.google && !sessionTokenRef.current) {
      var _google, _google$maps;

      var googleMapsPlaces = (_google = window.google) === null || _google === void 0 ? void 0 : (_google$maps = _google.maps) === null || _google$maps === void 0 ? void 0 : _google$maps.places;
      if (googleMapsPlaces) sessionTokenRef.current = new googleMapsPlaces.AutocompleteSessionToken();
    }
  }, [isScriptReady, sessionTokenRef]);

  var _usePlacesAutocomplet = usePlacesAutocomplete({
    initOnMount: false,
    debounce: 300,
    requestOptions: _objectSpread(_objectSpread(_objectSpread({}, placesFilterTypes ? {
      types: placesFilterTypes
    } : {}), placesLocationBias ? {
      locationBias: placesLocationBias
    } : {}), {}, {
      sessionToken: true && (_ref6 = window || {}) !== null && _ref6 !== void 0 && (_ref6$google = _ref6.google) !== null && _ref6$google !== void 0 && (_ref6$google$maps = _ref6$google.maps) !== null && _ref6$google$maps !== void 0 && _ref6$google$maps.places && sessionTokenRef.current instanceof window.google.maps.places.AutocompleteSessionToken ? sessionTokenRef.current : undefined
    }),
    cache: 24 * 60 * 60
  }),
      ready = _usePlacesAutocomplet.ready,
      _usePlacesAutocomplet2 = _usePlacesAutocomplet.suggestions,
      status = _usePlacesAutocomplet2.status,
      data = _usePlacesAutocomplet2.data,
      setValue = _usePlacesAutocomplet.setValue,
      init = _usePlacesAutocomplet.init;

  return {
    ready: ready,
    status: status,
    data: data,
    setValue: setValue,
    init: init
  };
};

export var useRenderSuggestions = function useRenderSuggestions(props) {
  var placesFilterTypes = props.placesFilterTypes,
      locationInputValue = props.locationInputValue,
      dropdownItemProps = props.dropdownItemProps,
      isScriptReady = props.isScriptReady,
      sessionTokenRef = props.sessionTokenRef,
      placesLocationBias = props.placesLocationBias;

  var _usePlacesAutocomplet3 = usePlacesAutocompleteLogic({
    placesFilterTypes: placesFilterTypes,
    isScriptReady: isScriptReady,
    sessionTokenRef: sessionTokenRef,
    placesLocationBias: placesLocationBias
  }),
      ready = _usePlacesAutocomplet3.ready,
      status = _usePlacesAutocomplet3.status,
      data = _usePlacesAutocomplet3.data,
      setValue = _usePlacesAutocomplet3.setValue,
      init = _usePlacesAutocomplet3.init;

  var _ref7 = dropdownItemProps || {},
      _ref7$itemRenderVaria = _ref7.itemRenderVariant,
      itemRenderVariant = _ref7$itemRenderVaria === void 0 ? 'with_break_line' : _ref7$itemRenderVaria,
      itemTextStyle = _ref7.itemTextStyle;

  var renderSuggestions = useCallback(function () {
    return status === 'OK' ? itemRenderVariant === 'with_break_line' ? /*#__PURE__*/_jsx(AddressDirectApplyList, _objectSpread({
      data: data
    }, props)) : /*#__PURE__*/_jsx(AddressSelectDropdown, _objectSpread({
      data: data
    }, props)) : status === 'ZERO_RESULTS' ? dropdownItemProps !== null && dropdownItemProps !== void 0 && dropdownItemProps.noResultElement ? dropdownItemProps === null || dropdownItemProps === void 0 ? void 0 : dropdownItemProps.noResultElement : /*#__PURE__*/_jsx("li", {
      children: /*#__PURE__*/_jsx(Title, {
        content: "Nessun risultato trovato",
        fontWeight: "normal",
        fontSize: "small",
        twStyle: itemTextStyle ? itemTextStyle : {
          "lineHeight": "1.313rem"
        },
        textColor: "neutral-700",
        icon: "ExclamationCircleIcon"
      })
    }) : (dropdownItemProps === null || dropdownItemProps === void 0 ? void 0 : dropdownItemProps.loadingElement) || /*#__PURE__*/_jsx("li", {
      children: /*#__PURE__*/_jsx(Title, {
        content: "loading...",
        fontWeight: "normal",
        fontSize: "small",
        twStyle: itemTextStyle ? itemTextStyle : {
          "lineHeight": "1.313rem"
        },
        textColor: "neutral-700"
      })
    });
  }, [data, dropdownItemProps === null || dropdownItemProps === void 0 ? void 0 : dropdownItemProps.loadingElement, dropdownItemProps === null || dropdownItemProps === void 0 ? void 0 : dropdownItemProps.noResultElement, itemRenderVariant, itemTextStyle, props, status]);
  useEffect(function () {
    try {
      if (locationInputValue) init();
      setValue(locationInputValue);
    } catch (error) {
      console.error('Error initializing autocomplete:', error);
    }
  }, [init, locationInputValue, setValue]);
  return {
    ready: ready,
    renderSuggestions: renderSuggestions,
    status: status
  };
};

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "google-auto-complete-inputhooks___StyledDiv",
  componentId: "sc-w8zbn-0"
})({
  "display": "flex",
  "width": "100%",
  "flexDirection": "row",
  "alignItems": "center",
  "gap": "0.5rem"
});

var _StyledMarkerPinIcon = /*#__PURE__*/_styled(MarkerPinIcon).withConfig({
  displayName: "google-auto-complete-inputhooks___StyledMarkerPinIcon",
  componentId: "sc-w8zbn-1"
})({
  "maxHeight": "18px",
  "minHeight": "18px",
  "minWidth": "18px",
  "maxWidth": "18px",
  "--tw-text-opacity": "1",
  "color": "rgb(107 114 128 / var(--tw-text-opacity))"
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "google-auto-complete-inputhooks___StyledDiv2",
  componentId: "sc-w8zbn-2"
})({
  "display": "flex",
  "width": "100%",
  "maxWidth": "95%",
  "flexDirection": "column",
  "flexWrap": "wrap",
  "gap": "0.25rem",
  "textAlign": "left"
});